import { render, staticRenderFns } from "./GoodsTabsPreview.vue?vue&type=template&id=02123fd6&scoped=true"
import script from "./GoodsTabsPreview.vue?vue&type=script&lang=js"
export * from "./GoodsTabsPreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsTabsPreview.vue?vue&type=style&index=0&id=02123fd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02123fd6",
  null
  
)

export default component.exports